var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('time',{attrs:{"datetime":_vm.isoDateTime,"title":_vm.fullFormattedDateTime}},[_vm._v(_vm._s(_vm.formattedDateTime))])
}
var staticRenderFns = []

export { render, staticRenderFns }